<template>
  <div class="modal-wrapper">
    <div class="navbar">
      <span v-if="isEditing">Edit Poll</span>
      <span v-else>New Poll</span>
      <span class="material-icons" @click="close">clear</span>
    </div>
    <div class="title-of-questions-page">
      <span>Poll title:</span>
      <input type="text" v-model="title" />
    </div>
    <div class="date-points-required" id="start-date">
      <div class="agenda-form-dates">
        <div class="start">
          <div class="start-date">
            <span>{{ $t("adminAgenda.startDate") }}</span>
            <input type="date" v-model="inputDateFrom" />
          </div>
          <div class="start-time">
            <span>{{ $t("adminAgenda.startTime") }}</span>
            <input
              type="text"
              :placeholder="$t('adminAgenda.hoursMinutes')"
              :class="{ 'invalid-input-item': !timeFromValid }"
              v-model="inputTimeFrom"
            />
          </div>
        </div>
        <div class="end">
          <div class="end-date">
            <span>{{ $t("adminAgenda.endDate") }}</span>
            <input type="date" :disabled='!inputDateFrom' :min="inputDateFrom" v-model="inputDateTo" />
          </div>
          <div class="end-time">
            <span>{{ $t("adminAgenda.endTime") }}</span>
            <input
              type="text"
              :placeholder="$t('adminAgenda.hoursMinutes')"
              :class="{ 'invalid-input-item': !timeToValid }"
              v-model="inputTimeTo"
            />
          </div>
        </div>
      </div>
      <div class="wrap-rest">
        <div class="timezone">
          <div class="title">Select timezone</div>
          <select v-model="selectedTimezoneOffset" @change="updateCurMoment">
            <option :value="0">GMT +0</option>
            <option :value="1">GMT +1</option>
            <option :value="-1">GMT -1</option>
            <option :value="2">GMT +2</option>
            <option :value="-2">GMT -2</option>
            <option :value="3">GMT +3</option>
            <option :value="-3">GMT -3</option>
            <option :value="4">GMT +4</option>
            <option :value="-4">GMT -4</option>
            <option :value="5">GMT +5</option>
            <option :value="-5">GMT -5</option>
            <option :value="6">GMT +6</option>
            <option :value="-6">GMT -6</option>
            <option :value="7">GMT +7</option>
            <option :value="-7">GMT -7</option>
            <option :value="8">GMT +8</option>
            <option :value="-8">GMT -8</option>
            <option :value="9">GMT +9</option>
            <option :value="-9">GMT -9</option>
            <option :value="10">GMT +10</option>
            <option :value="-10">GMT -10</option>
            <option :value="11">GMT +11</option>
            <option :value="-11">GMT -11</option>
            <option :value="12">GMT +12</option>
            <option :value="-12">GMT -12</option>
          </select>
          <div class="current-timezone">
            <span>{{ "(" + currentMoment.format("HH:mm:ss") + ")" }}</span>
          </div>
        </div>
        <div>
          <label for="required">Required</label>
          <input id="required" type="checkbox" v-model="required" />
        </div>
        <div>
          <label for="points">Points</label>
          <input type="text" id="points" v-model="points" />
        </div>
        <div>
          Is Reg?
          <input type="checkbox" v-model="isReg" />
        </div>
      </div>
    </div>
    <div class="dropdown-wrap">
      <span> Select tags: </span>
      <DropDown
        :id="1"
        :options="tags"
        displayKey="tag_name"
        :isOpened="isOpened"
        :selectAll="true"
        @get-value="handleTags"
        @set-opened="handleSetOpened"
      />
    </div>
    <div class="buttons-wrap">
      <button class="button-round" @click="edit" v-if="isEditing">Submit edit</button>
      <button class="button-round" @click="save" v-else>Save</button>
      <button class="button-round" @click="close">Cancel</button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import DropDown from "@/components/list-of-attendees/DropDown.vue";
const timeRegex = RegExp("^(2[0-3]|[01]?[0-9]):([0-5][0-9])$");
import moment from "moment";
export default {
  components: {
    DropDown
  },
  props: {
    isEditing: {
      type: Boolean
    },
    selectedPoll: {
      type: Object
    }
  },
  data() {
    return {
      moment,
      selectedTimezoneOffset: moment().utcOffset() / 60,
      currentMoment: moment(),
      updateMomentId: null,
      id: null,
      title: "",
      data: [],
      newAnswer: "",
      questionTypes: ["select", "text", "badge", "checkbox"],
      hasSearchShortcutError: false,
      pollStart: null,
      pollEnd: null,
      required: false,
      points: 0,
      tags: [],
      selectedTags: [],
      openDropDownBool: false,
      isReg: false,
      inputDateFrom: "",
      inputTimeFrom: "",
      inputDateTo: "",
      inputTimeTo: "",
      isOpened: false,
      pls_id:null
    };
  },
  computed: {
    timeFromValid() {
      return (
        this.inputTimeFrom.trim().length !== 0 &&
        timeRegex.test(this.inputTimeFrom)
      );
    },
    timeToValid() {
      return (
        this.inputTimeTo.trim().length !== 0 && timeRegex.test(this.inputTimeTo)
      );
    }
  },
  mounted() {
    this.init();
    this.updateMomentId = setInterval(() => {
      this.updateCurMoment();
    }, 1000);
    console.log(this.selectedPoll);
  },
  beforeDestroy() {
    clearInterval(this.updateMomentId);
  },
  methods: {
    updateCurMoment() {
      this.currentMoment = moment()
        .utcOffset(this.selectedTimezoneOffset, true)
        .utc();
    },
    handleSetOpened() {
      this.isOpened = !this.isOpened;
    },
    removeAnswer(question) {
      let options = this.$refs["select-element"][0].options;
      question.answers.splice(options.selectedIndex, 1);
      this.data = [...this.data];
    },
    init() {
      this.getAllTags();
      let page;
      if (this.page && this.page.title && this.page.data) {
        page = JSON.stringify(this.page);
        page = JSON.parse(page);
        this.id = page.ppg_id;
        this.title = page.title;
        this.data = page.data;
      }
      if(this.selectedPoll) {
        console.log(this.selectedPoll)
        let p = this.selectedPoll
        this.title = p.pls_name
        this.inputDateFrom = p.pls_start.split(' ')[0]
        this.inputTimeFrom = p.pls_start.split(' ')[1].slice(0,p.pls_start.split(' ')[1].length-3)
        this.inputDateTo = p.pls_end.split(' ')[0]
        this.inputTimeTo = p.pls_end.split(' ')[1].slice(0,p.pls_start.split(' ')[1].length-3)
        this.required = p.pls_required
        this.points = p.pls_points
        this.isReg = p.pls_code == 'reg'? true : false
        this.pls_id = p.pls_id
      }
    },
    deleteQuestion(index) {
      this.data.splice(index, 1);
    },
    async save() {
      const data = {
        pls_name: this.title,
        pls_code: this.isReg ? "reg" : null,
        pls_start: moment(this.inputDateFrom + "T" + this.inputTimeFrom)
          .utcOffset(this.selectedTimezoneOffset, true)
          .utc()
          .format(),
        pls_end: moment(this.inputDateTo + "T" + this.inputTimeTo)
          .utcOffset(this.selectedTimezoneOffset)
          .utc()
          .format(),
        pls_points: this.points,
        pls_required: this.required ? 1 : 0
      };
      try {
        const res = await api.addNewPoll(data);
        const pls_id = res.data.pls_id;
        if (this.selectedTags.length > 0) {
          this.selectedTags.forEach(tag => {
            this.addTagToPoll(pls_id, tag.tag_id);
          });
          this.openToast("Success");
        }
        this.$emit("close");
      } catch (error) {
        this.handleError(error);
      }
    },
    async edit() {
      const data = {
        pls_id:this.pls_id,
        pls_name: this.title,
        pls_code: this.isReg ? "reg" : null,
        pls_start: moment(this.inputDateFrom + "T" + this.inputTimeFrom)
          .utcOffset(this.selectedTimezoneOffset, true)
          .utc()
          .format(),
        pls_end: moment(this.inputDateTo + "T" + this.inputTimeTo)
          .utcOffset(this.selectedTimezoneOffset)
          .utc()
          .format(),
        pls_points: this.points,
        pls_required: this.required ? 1 : 0
      };
      try {
        const res = await api.editPoll(data)
        this.openToast("Success");
        this.$emit("close");
        this
      } catch (error) {
        this.handleError(error)
      }
    },
    close() {
      this.$emit("close");
    },
    async getAllTags() {
      try {
        const res = await api.getTags();
        this.tags = res.data.result;
        console.log(res.data.result);
      } catch (error) {
        this.handleError(error);
      }
    },
    async addTagToPoll(pls_id, tag_id) {
      try {
        const res = await api.addTagToPoll({ pls_id, tag_id });
        console.log(res.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    openDropDown() {
      this.openDropDownBool = !this.openDropDownBool;
      console.log(this.openDropDownBool);
    },
    handleTags(tags) {
      this.selectedTags = tags;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  overflow: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  width: 90%;
  height: 90%;
  background: white;
  .navbar {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .material-icons {
      cursor: pointer;
      position: absolute;
      right: 10px;
    }
  }
  .title-of-questions-page {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      width: auto;
      margin: 10px;
    }
    input {
      max-width: 80%;
    }
  }
  .dropdown-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .timezone {
    display: flex;
    position: relative;
    .title {
      position: absolute;
      left: 0;
      top: -20px;
    }
  }
  .questions {
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .button-round {
      width: 30px;
      min-width: 30px;
      height: 30px;
      span {
        font-size: 15px;
      }
    }
    .type {
      margin: 0 10px;
      min-width: 120px;
    }
    .title {
      margin: 0 10px;
      max-width: 300px;
    }
    .select {
      min-width: 200px;
      display: flex;
      select {
        width: 70%;
      }
      button {
        margin-left: 5%;
        width: auto;
      }
    }
    .add-new-answer {
      margin: 0 10px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .button-round-small {
        margin-left: 10px;
        width: 40px;
        min-width: 0;
      }
    }
    .search-question {
      display: flex;
      align-items: center;
      margin-left: 10px;
      input[type="checkbox"] {
        min-width: 15px;
        min-height: 15px;
        margin-right: 30px;
      }
    }
  }
  .date-points-required {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    margin: 30px 0;
    & > div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }
    .wrap-rest {
      margin-top: 20px;
      width: 100%;
    }
    input[type="text"] {
      width: 300px;
    }
    input:focus {
      outline: none;
    }
    .invalid-input-item {
      border: 1px solid red;
      box-shadow: 1px 1px 5px 1px red;
    }
  }
  .buttonz {
    margin: 20px auto;
  }
  .buttons-wrap {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin: 0 0 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
